















import { snakeCase } from 'lodash'
import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'

import ModelSetter from '../../../../../Mixins/ModelSetter'
import SwitchInput from '../../../../Pi/fields/SwitchInput/SwitchInput.vue'
import { ConditionMode, ConditionType } from '../../types'

@Component({
  components: {
    SwitchInput
  },
  data() {
    return {
      snakeCase
    }
  }
})
export default class LessGreaterConditionMode extends Mixins(ModelSetter) {
  @VModel() model!: ConditionMode

  @Prop({ type: Boolean, default: false }) disabled!: boolean

  @Prop() type!: ConditionType.Sent | ConditionType.Activity

  get mode(): boolean {
    return this.model === ConditionMode.Greater
  }

  set mode(value: boolean) {
    if (!value) {
      this.model = ConditionMode.Less
    } else {
      this.model = ConditionMode.Greater
    }
  }

}
